import { render, staticRenderFns } from "./EditSerialNumber.vue?vue&type=template&id=63a123c0&scoped=true&"
import script from "./EditSerialNumber.vue?vue&type=script&lang=js&"
export * from "./EditSerialNumber.vue?vue&type=script&lang=js&"
import style0 from "./EditSerialNumber.vue?vue&type=style&index=0&id=63a123c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a123c0",
  null
  
)

export default component.exports